export enum FollowUpStatus {
  FollowupScheduled = 1,
  FollowupComplete = 2,
  Closed = 3,
  NA = 4,
}